import React from 'react';

import { getTranslateFunc } from '../../../../utils/stringUtil';
import IbButton from '../../../../components/common/IbButton';
import IbTypography from '../../../../components/common/IbTypography';
import IbConfirmModal from '../../../../components/common/IbConfirmModal';

interface IDeleteToolsetProps {
  visible: boolean;
  loading?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
}

const DeleteProject: React.FC<IDeleteToolsetProps> = ({ visible, loading, onConfirm, onCancel }) => {
  const translate = getTranslateFunc('Project: Confirm: Delete:');

  return (
    <IbConfirmModal
      footer={
        <>
          <IbButton key="delete-confirm" status="error" onClick={onConfirm}>
            {translate('Confirm')}
          </IbButton>
          <IbButton key="delete-cancel" type="secondary" onClick={onCancel}>
            {translate('Cancel')}
          </IbButton>
        </>
      }
      loading={loading}
      title={translate('Title')}
      visible={visible}
      onCancel={onCancel}
    >
      <IbTypography.Paragraph type="secondary">{translate('Content')}</IbTypography.Paragraph>
    </IbConfirmModal>
  );
};

export default DeleteProject;
